import { saveAllChanges } from './pdfOperations';
import { removePdfContent } from './pdfContentRemoval';

/**
 * Worker-safe entrypoint for the save pipeline.
 *
 * Wraps saveAllChanges in the message shape the worker uses so the same
 * function can run inside a worker OR be unit-tested as a plain module
 * (Vitest's node env has no Worker). The worker file imports this and
 * calls it in onmessage; the test file imports it and calls it directly.
 *
 * Keep this thin — all PDF logic stays in saveAllChanges so the contract
 * test at overlayPersistence.test.js continues to cover both the sync
 * path and the worker path.
 *
 * @param {{
 *   arrayBuffer: ArrayBuffer,
 *   edits?: Array,
 *   annotations?: Array,
 *   options?: { fieldData?: Array, flatten?: boolean, preserveOverlays?: boolean },
 * }} payload
 * @returns {Promise<Uint8Array>}
 */
export async function runSavePipeline({ arrayBuffer, edits, annotations, options = {} }) {
  if (options.contentRemoval) return removePdfContent(arrayBuffer, options.contentRemoval.targets, options.contentRemoval);
  return saveAllChanges(arrayBuffer, { ...options, edits, annotations });
}
